import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from '../../service/admin.service';
import * as constants from '../../app.constants';
import { NotificationsService } from 'angular2-notifications';
import { PagerService } from '../../pipe/pagination';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';

@Component({
  selector: 'reported-sellers',
  template: require('./reported-sellers.component.html'),
  styles: [require('./reported-sellers.component.css')]
})

export class ReportedSellersComponent implements OnInit, AfterViewInit {

  public errorMsg: string;
  public model: any;
  public clearFilter = false;
  public search = '';
  public pager: any = {};
  public user: any;
  public showLoader: boolean = false;
  public count: any;
  public pageSize: number = 10;
  public page: number = 1;
  @ViewChild('approveRejectModal') public approveRejectModal: ModalComponent;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public _notificationsService: NotificationsService,
    private adminService: AdminService,
    private pagerService: PagerService) {
  }

  public ngOnInit(): void {
    this.getReportedSellersData(1);
  }

  public ngAfterViewInit(): void {
  }

  protected getReportedSellersData(pageNo): void {
    let url = constants.URLs.reportedSellers + '?page='+ pageNo +'&page_size=10';
    if( this.search.length > 0 ){
      url = url + '&search=' + this.search;
    }

    this.adminService
      .getCall(url, true)
      .then((res) => {
          this.model = res.results;
          this.count = res.count;
          this.errorMsg = null;
          this.page = pageNo;
          this.pager = this.pagerService.getPager(this.count, this.page, this.pageSize);
      })
      .catch((error: any) => {
          try {
            this.errorMsg = error.json().error_msg || constants.messages.serverError;
            // console.debug('Dashboard1Component- an error occurred', error);
          } catch (e) {
            this.errorMsg = error.message ? error.message : constants.messages.serverError;
            // console.error('Dashboard1Component- an error occurred', error);
            this.adminService.showErrorToast(this.errorMsg);
          }
      });
  }

  public applyFilters() {
    this.clearFilter = this.search.length !== 0;
    this.getReportedSellersData(1);
  }

  public clearFilters() {
    this.clearFilter = false;
    this.search = '';
    this.getReportedSellersData(1);
  }

  public goToPage(selectedPage: number) {
    if (this.pager.currentPage === selectedPage) {
      return;
    }
    if (selectedPage < 1 || selectedPage > this.pager.totalPages) {
      return;
    }
    // Show tickets with selected page number and existing page size
    this.getReportedSellersData(selectedPage);
  }

  public openApproveRejectModal(user): void {
    this.user = user;
    this.errorMsg = null;
    this.approveRejectModal.open();
  }

  public closeApproveRejectModal(): void {
    this.approveRejectModal.close();
    this.user = null;
  }

  public approveRejectTicket(user, action: string): void {
    let flag: number;
    switch (action) {
      case 'approve':
        flag = 1;
        break;
      case 'reject':
        flag = 2;
        break;
      default:
        return;
    }
    let url = constants.URLs.approveRejectFakeTicketRequest.replace('{user_id}', this.user.user_id);
    let model = {
      flag: flag
    };
    this.showLoader = true;
    this.adminService
      .approveRejectTicket(url, model, true)
      .then((res) => {
        console.log('Approve Reject Ticket res');
        console.log(res);
        this.showLoader = false;
        this.closeApproveRejectModal();
        let msg =
          flag === 1 ? constants.messages.fakeTicketRequestApproved : constants.messages.fakeTicketRequestRejected;
        this.adminService.showSuccessToast(msg);
        this.getReportedSellersData(1);
      })
      .catch((error: any) => {
        this.showLoader = false;
        try {
          this.errorMsg = error.json().error_msg || constants.messages.serverError;
          console.debug('approveRejectTicket- an error occurred', error);
        } catch (e) {
          this.errorMsg = error.message ? error.message : constants.messages.serverError;
          console.error('approveRejectTicket- an error occurred', error);
        }
      });
  }

  public getColspan(): number {
    let colspan;
    colspan = 7;
    return colspan;
  }

  approveRejectSeller(user, action){
    let flag: number;
    switch (action) {
      case "approve":
        flag = 1;
        break;
      case "reject":
        flag = 2;
        break;
      default:
        return;
    }

    let url = constants.URLs.updateReportedSellerStatus.replace(
      "{user_id}",
      this.user.flagged_user.user_id
    );
    
    let model = {
      flag_status: flag,
    };

    this.showLoader = true;
    this.adminService
      .approveRejectTicket(url, model, true)
      .then((res) => {
        this.showLoader = false;
        this.closeApproveRejectModal();
        let msg =
          flag === 1
            ? constants.messages.reportedSellerApproved
            : constants.messages.reportedSellerRejected;
        this.adminService.showSuccessToast(msg);
        this.getReportedSellersData(this.page);
      })
      .catch((error: any) => {
        this.showLoader = false;
        try {
          this.errorMsg =
            error.json().error_msg || constants.messages.serverError;
        } catch (e) {
          this.errorMsg = error.message
            ? error.message
            : constants.messages.serverError;
        }
      });
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/manage/reported-sellers/reported-sellers.component.ts